import { useState } from 'react';
import { _addLeadSourceCost, _updateLeadSourceCost } from 'controllers/leads/leads_controller';

export function useLeadSourceCost() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const addLeadSourceCost = async (payload) => {
    setLoading(true);
    setError(null);
    try {
      const result = await _addLeadSourceCost(payload);
      setLoading(false);
      return result;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  const updateLeadSourceCost = async (id, payload) => {
    setLoading(true);
    setError(null);
    try {
      const result = await _updateLeadSourceCost(id, payload);
      setLoading(false);
      return result;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  return {
    addLeadSourceCost,
    updateLeadSourceCost,
    loading,
    error,
  };
}
